export interface UserData {
	lastName?: string;
	firstName?: string;
	email?: string;
	phone?: string;
	city?: string;
	cityName?: string;
	birthDate?: string;
	roles?: ("DEPOSIT" | "HOME_SAVING" | "MORTGAGE" | "PERSONAL_LOAN" | "RETAIL_ACCOUNT" | "ADMIN" | string)[];
}

export class User {
	private readonly data: UserData;

	constructor(data: UserData) {
		this.data = data;
	}

	public isSignedIn(): boolean {
		return !!this.data?.email;
	}

	public getEmail(): string {
		return this.data?.email || "";
	}

	public hasRole(role: string): boolean {
		return this.data?.roles?.includes(role);
	}

	public getFirstName(): string {
		return this.data?.firstName || "";
	}

	public getLastName(): string {
		return this.data?.lastName || "";
	}

	public getFullName(): string {
		const { firstName, lastName } = this.data || {};
		return firstName && lastName ? `${firstName} ${lastName}` : "";
	}

	public getPhoneNumber(): string {
		return this.data?.phone || "";
	}

	public getCityName(): string {
		return this.data?.cityName || "";
	}

	public getBirthDate(): string {
		return this.data?.birthDate || "";
	}

	public getBirthYear(): number | undefined {
		const yearString = this.data?.birthDate?.split("-")[0];
		return yearString ? Number.parseInt(yearString, 10) : undefined;
	}
}
